import React from "react";
import FilterLayout from "../../../components/FilterLayout/FilterLayout";
import { Button, Form, Select } from "antd";
import { DatePicker as DatePickerJalali } from "antd-jalali";
import useMessageReport from "../../../hooks/useMessagesReport";
import FormWrapper from "../../../components/FormWrapper/FormWrapper";

const FilterMessagesReport = () => {
  const {
    provinces,
    selectedCity,
  } = useMessageReport();
  const { Option } = Select;
  return (
    <FilterLayout>
      <FormWrapper>
        <Select
          className="border-black-8 input-size sm:w-100 mb-10 "
          value={"همه استان ها"}
        >
          <Option value={null} name="همه استان ها">
            همه استان ها
          </Option>
          {provinces.map((item) => {
            return (
              <Option value={item.id.toString()} name={item.name}>
                {item.name}
              </Option>
            );
          })}
        </Select>
        <Select
          className="border-black-8 input-size sm:w-100 mb-10 "
          value={selectedCity?.name || "همه شهرها"}
        >
          <Option value={null} name="همه شهر ها">
            همه شهر ها
          </Option>
          {provinces.map((item) => {
            return (
              <Option value={item.id.toString()} name={item.name}>
                {item.name}
              </Option>
            );
          })}
        </Select>
        <Select
          className="border-black-8 input-size sm:w-100 mb-10 "
          value={selectedCity?.name || "همه دسته بندی ها"}
        >
          <Option value={null} name="همه دسته بندی ها">
            همه دسته بندی ها
          </Option>
          {provinces.map((item) => {
            return (
              <Option value={item.id.toString()} name={item.name}>
                {item.name}
              </Option>
            );
          })}
        </Select>
        <Form.Item
          className="input-size sm:w-100"
          style={{ marginBottom: "16px" }}
          name="start_buy_date"
          colon={false}
        >
          <DatePickerJalali.RangePicker
            className="input-black border-black-8 w-100"
            format="YYYY-MM-DD"
          />
        </Form.Item>
        <Select
          className="border-black-8 input-size  mb-10 "
          value={selectedCity?.name || "همه کاربران"}
        >
          <Option value={null} name="همه کاربران">
            همه کاربران
          </Option>
          {provinces.map((item) => {
            return (
              <Option value={item.id.toString()} name={item.name}>
                {item.name}
              </Option>
            );
          })}
        </Select>

        <Select
          className="border-black-8 input-size sm:w-100 mb-10 "
          value={selectedCity?.name || "همه خودرو ها"}
        >
          <Option value={null} name="همه خودرو ها">
            همه خودرو ها
          </Option>
          {provinces.map((item) => {
            return (
              <Option value={item.id.toString()} name={item.name}>
                {item.name}
              </Option>
            );
          })}
        </Select>
        <div className="input-size" />
        <Button className="button-secondary input-size sm:w-100 mb-10">
          فیلتر
        </Button>
      </FormWrapper>
    </FilterLayout>
  );
};

export default FilterMessagesReport;
